import { useEffect, useState } from "react";
import { PINGFLO_TOUR_ACTIVE_EVENT, PINGFLO_TOUR_CLEARED_EVENT, UI_TOUR_SETTLED_EVENT } from "./tourEvents";
import { isPingfloTourRunning } from "./tourTarget";

/** True while Pingflo is walking the UI, so empty club screens can show sample rows. */
export function useTourDemoActive() {
  const [active, setActive] = useState(() => isPingfloTourRunning());
  useEffect(() => {
    const sync = (event) => {
      if (event?.type === PINGFLO_TOUR_CLEARED_EVENT || event?.type === UI_TOUR_SETTLED_EVENT) {
        setActive(false);
        return;
      }
      if (typeof event?.detail?.active === "boolean") {
        setActive(event.detail.active);
        return;
      }
      setActive(isPingfloTourRunning());
    };
    window.addEventListener(PINGFLO_TOUR_ACTIVE_EVENT, sync);
    window.addEventListener(PINGFLO_TOUR_CLEARED_EVENT, sync);
    window.addEventListener(UI_TOUR_SETTLED_EVENT, sync);
    return () => {
      window.removeEventListener(PINGFLO_TOUR_ACTIVE_EVENT, sync);
      window.removeEventListener(PINGFLO_TOUR_CLEARED_EVENT, sync);
      window.removeEventListener(UI_TOUR_SETTLED_EVENT, sync);
    };
  }, []);
  return active;
}
